// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acp-planning-table-dropdown {
  display: flex;
  gap: 16px;
}
.acp-planning-table-dropdown .select-all-task,
.acp-planning-table-dropdown .select-duration,
.acp-planning-table-dropdown .select-calender {
  width: 150px;
  height: 31px;
}
.acp-planning-table-dropdown .select-duration {
  width: 100px;
}
.acp-planning-table-dropdown .select-calender {
  width: 92px;
}

.row-capacity-highlight {
  font-weight: bold;
}

.headerWrapper {
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}

.capacityManagement .subHeaderWrapper {
  padding-bottom: 0px !important;
}
.capacityManagement .dropdown {
  margin-left: 16px;
}
.capacityManagement .excelIcon {
  margin-top: 8px;
  margin-left: -10px;
}

.weekStartRange {
  position: relative;
  z-index: 102;
}
.weekStartRange .calenderWeeklyIcon {
  cursor: pointer;
}

.inputWeekStartRange {
  width: 126px;
  height: 31px;
  border: 1px solid #acacac;
  border-radius: 4px;
  padding-left: 5px;
  cursor: pointer;
}

.inputWeekStartRange:focus-visible {
  border: 1px solid #acacac;
  outline: none;
}

.calenderStartRange {
  position: absolute;
  z-index: 102;
  margin-top: 5px;
}

.calenderWeeklyIcon {
  position: absolute;
  left: 100px;
  top: 5px;
}

.overlayCalender {
  width: 100%;
  height: 100%;
  background: blue;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.1;
}

.circularRightArrow {
  display: flex;
  align-items: center;
}

.headerWrapper .p-dropdown .p-dropdown-label.p-placeholder,
.headerWrapper .inputWeekStartRange {
  font-size: 12px !important;
  line-height: 15px !important;
  color: #595959;
  font-weight: 500;
}
.headerWrapper .inputWeekStartRange:focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.circularRightArrowDisable img {
  filter: grayscale(100%) opacity(50%);
  cursor: pointer;
}

.select-all-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.taskAndProjectDetails table thead .p-filter-column {
  max-width: 100px !important;
}
.taskAndProjectDetails table thead th.p-filter-column .p-column-filter .p-fluid {
  min-width: 95% !important;
}
.taskAndProjectDetails .p-datatable .p-datatable-tbody > tr {
  height: 40px !important;
}
.taskAndProjectDetails .p-calendar {
  width: calc(100% - 24px);
}
.taskAndProjectDetails table thead th:nth-child(1) {
  height: 4rem;
}
.taskAndProjectDetails .item-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.text-bold {
  font-weight: 700;
}

.wave_specification_icon {
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--primary-color);
  background: none;
  border: none;
  padding: 0;
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/Planning/CapacityManagementPlaningHeader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;AACF;AACE;;;EAGE,YAAA;EACA,YAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,WAAA;AADJ;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AAFF;;AAOE;EACE,8BAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,eAAA;EACA,kBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,YAAA;AAPF;AASE;EACE,eAAA;AAPJ;;AAWA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AARF;;AAWA;EACE,yBAAA;EACA,aAAA;AARF;;AAWA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AARF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;AAdF;;AAmBE;;EAEE,0BAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,kDAAA;EACA,qBAAA;AAjBJ;;AAsBE;EACE,oCAAA;EACA,eAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AApBF;;AAyBE;EACE,2BAAA;AAtBJ;AAyBE;EACE,yBAAA;AAvBJ;AA0BE;EACE,uBAAA;AAxBJ;AA2BE;EACE,wBAAA;AAzBJ;AA4BE;EAIE,YAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA9BJ;;AAmCA;EACE,eAAA;AAhCF;;AAkCA;EACE,gBAAA;AA/BF;;AAiCA;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AA9BF","sourcesContent":[".acp-planning-table-dropdown {\n  display: flex;\n  gap: 16px;\n\n  .select-all-task,\n  .select-duration,\n  .select-calender {\n    width: 150px;\n    height: 31px;\n  }\n\n  .select-duration {\n    width: 100px;\n  }\n\n  .select-calender {\n    width: 92px;\n  }\n}\n\n.row-capacity-highlight {\n  font-weight: bold;\n}\n\n.headerWrapper {\n  display: flex;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.capacityManagement {\n\n  .subHeaderWrapper {\n    padding-bottom: 0px !important;\n  }\n\n  .dropdown {\n    margin-left: 16px;\n  }\n\n  .excelIcon {\n    margin-top: 8px;\n    margin-left: -10px;\n  }\n}\n\n.weekStartRange {\n  position: relative;\n  z-index: 102;\n\n  .calenderWeeklyIcon {\n    cursor: pointer;\n  }\n}\n\n.inputWeekStartRange {\n  width: 126px;\n  height: 31px;\n  border: 1px solid #acacac;\n  border-radius: 4px;\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n.inputWeekStartRange:focus-visible {\n  border: 1px solid #acacac;\n  outline: none;\n}\n\n.calenderStartRange {\n  position: absolute;\n  z-index: 102;\n  margin-top: 5px;\n}\n\n.calenderWeeklyIcon {\n  position: absolute;\n  left: 100px;\n  top: 5px;\n}\n\n// .inputWeekStartRange-selected,\n// .inputWeekEndRange-selected {\n//   background: #003da5;\n//   color: #ffff !important;\n// }\n\n.overlayCalender {\n  width: 100%;\n  height: 100%;\n  background: blue;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.1;\n}\n\n.circularRightArrow {\n  display: flex;\n  align-items: center;\n}\n\n.headerWrapper {\n\n  .p-dropdown .p-dropdown-label.p-placeholder,\n  .inputWeekStartRange {\n    font-size: 12px !important;\n    line-height: 15px !important;\n    color: #595959;\n    font-weight: 500;\n  }\n\n  .inputWeekStartRange:focus {\n    outline: none;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    border-color: #86b7fe;\n  }\n}\n\n.circularRightArrowDisable {\n  img {\n    filter: grayscale(100%) opacity(50%);\n    cursor: pointer;\n  }\n}\n\n.select-all-checkbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.taskAndProjectDetails {\n\n  table thead .p-filter-column {\n    max-width: 100px !important;\n  }\n\n  table thead th.p-filter-column .p-column-filter .p-fluid {\n    min-width: 95% !important;\n  }\n\n  .p-datatable .p-datatable-tbody>tr {\n    height: 40px !important;\n  }\n\n  .p-calendar {\n    width: calc(100% - 24px);\n  }\n\n  table thead th:nth-child(1) {\n    // display: flex;\n    // align-items: center;\n    // justify-content: center;\n    height: 4rem;\n  }\n\n  .item-center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    // height: 5rem;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n.text-bold{\n  font-weight: 700;\n}\n.wave_specification_icon {\n  cursor: pointer;\n  font-size: 1.5rem;\n  color: var(--primary-color);\n  background: none;\n  border: none;\n  padding: 0;\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
